import React from 'react';
import PropTypes from 'prop-types';
import { StatusIndicator } from '@amzn/awsui-components-react-v3';

const statusConfig = {
	COMPLETED: { type: 'success', colorOverride: 'green' },
	COMPLETE: { type: 'success', colorOverride: 'green' },
	COMPLIANT: { type: 'success', colorOverride: 'green' },
	PENDING_SCAN: { type: 'pending', colorOverride: 'blue' },
	PENDING: { type: 'pending', colorOverride: 'blue' },
	DISCUSSION_PENDING: { type: 'in-progress', colorOverride: 'yellow' },
	UNDER_OBSERVATION: { type: 'warning', colorOverride: 'yellow' },
	FAILED: { type: 'error', colorOverride: 'red' },
	SCHEDULED: { type: 'pending', colorOverride: 'blue' },
	PENDING_SETUP: { type: 'pending', colorOverride: 'blue' },
	EXPIRED: { type: 'stopped', colorOverride: 'red' },
	QUEUED: { type: 'pending', colorOverride: 'grey' },
	WAITING: { type: 'pending', colorOverride: 'blue' },
	RUNNING: { type: 'in-progress', colorOverride: 'blue' },
	RE_RUN: { type: 'in-progress', colorOverride: 'blue' },
	OVERRIDEN: { type: 'info', colorOverride: 'grey' },
	SKIPPED: { type: 'stopped', colorOverride: 'grey' },
	CANCELLED: { type: 'stopped', colorOverride: 'grey' },
	TOTAL: { type: 'info', colorOverride: 'blue' },
	'IN PROGRESS': { type: 'pending', colorOverride: 'green' },
	READY: { type: 'success', colorOverride: 'green' },
	SUBMITTED: { type: 'pending', colorOverride: 'blue' },
	DRAFT: { type: 'info', colorOverride: 'grey' },
	SENDING: { type: 'in-progress', colorOverride: 'blue' },
	CREATING: { type: 'in-progress', colorOverride: 'blue' },
	CREATED: { type: 'success', colorOverride: 'green' },
	PENDING_REVIEW: { type: 'pending', colorOverride: 'grey' },
	SCHEDULED_FOR_DEPLOYMENT: { type: 'pending', colorOverride: 'blue' },
	ACTIVE: { type: 'success', colorOverride: 'green' },
	DEPRECATED: { type: 'stopped', colorOverride: 'red' },
	PASSED: { type: 'success', colorOverride: 'green' },
	VALID: { type: 'success', colorOverride: 'green' },
	VALIDATION_PASSED: { type: 'success', colorOverride: 'green' },
	INVALID: { type: 'error', colorOverride: 'red' },
	VALIDATION_FAILED: { type: 'error', colorOverride: 'red' },
	VALIDATION_FATAL: { type: 'error', colorOverride: 'red' },
	VALIDATION_IN_PROGRESS: { type: 'in-progress', colorOverride: 'blue' },
};

const DEFAULT_CONFIG = { type: 'info', colorOverride: 'blue' };

export const getStatusConfig = (status) => statusConfig[status] || DEFAULT_CONFIG;

export default class ShowSnowStatus extends React.Component {
	render() {
		return <StatusIndicator {...this.getPropsFromStatus(this.props.status)} />;
	}

	getPropsFromStatus(status) {
		const config = getStatusConfig(status);

		return {
			...config,
			children: (
				<>
					{''}
					{status}
				</>
			),
		};
	}
}

ShowSnowStatus.propTypes = {
	status: PropTypes.string.isRequired,
};
